/** Canonical site URL, golden logo (SVG), and default social share image. */
export const SITE_ORIGIN = 'https://www.khodalfacilitymanagementservice.com';
export const SITE_LOGO_PATH = '/KHP_LOGO.svg';
export const SITE_LOGO_URL = `${SITE_ORIGIN}${SITE_LOGO_PATH}`;

/** Primary public brand (rebrand). */
export const SITE_BRAND_NAME = 'Khodal Housekeeping Agency';
/** Previous legal / trading name — use in “formerly known as” and schema alternateName for SEO continuity. */
export const SITE_BRAND_LEGACY = 'Khodal Facility Management Service';
export const SITE_BRAND_LEGACY_UPPER = 'KHODAL FACILITY MANAGEMENT SERVICE';

export const SITE_BRAND_TRANSITION = `Formerly known as ${SITE_BRAND_LEGACY}.`;

/** Logo and key images (alt text). */
export const SITE_LOGO_ALT = 'Khodal Housekeeping Agency Ahmedabad';

/** Local SEO — primary service city (copy + schema). */
export const SEO_PRIMARY_CITY = 'Ahmedabad';
export const SEO_STATE = 'Gujarat';

/** Homepage / global marketing line — facility + city + key corridors. */
export const SITE_BRAND_TAGLINE_SEO =
  'Khodal Housekeeping Agency — facility management, valet parking & manpower for offices, malls, hospitals & societies in Ahmedabad (SG Highway, Satellite, Bodakdev, Thaltej, Bopal, Narol & across Gujarat).';

export const SITE_CONTACT_CTA = 'Contact Khodal Housekeeping Agency today';

/** Open Graph / Twitter default share art (`public/preview.jpg`, 1200×630). Raster for WhatsApp/LinkedIn. */
export const OG_SHARE_IMAGE_URL = `${SITE_ORIGIN}/preview.jpg`;

/** Default homepage / global share copy (Open Graph). */
export const OG_DEFAULT_TITLE =
  'Khodal Housekeeping Agency Ahmedabad | Housekeeping, Valet Parking & Manpower';

export const OG_DEFAULT_DESCRIPTION =
  'Housekeeping agency in Ahmedabad: facility management, valet parking, manpower & commercial cleaning. Serving SG Highway, Satellite, Bodakdev, Thaltej, Bopal, Vastrapur & Narol. 100+ clients. Formerly Khodal Facility Management Service. Call +91 92654 72938.';

/** Twitter card title/description can be shorter than og:title. */
export const TWITTER_DEFAULT_TITLE = 'Khodal Housekeeping Agency — Ahmedabad';
export const TWITTER_DEFAULT_DESCRIPTION =
  'Housekeeping, valet parking & manpower in Ahmedabad — SG Highway, Satellite, Bodakdev, Thaltej & more.';

/** Meta keywords for homepage / crawler hints (sync with `public/index.html` when updating). */
export const SEO_HOME_KEYWORDS =
  'Khodal Housekeeping Agency Ahmedabad, housekeeping agency Ahmedabad, facility management company Ahmedabad, valet parking Ahmedabad, manpower services Ahmedabad, office cleaning Ahmedabad, society cleaning Ahmedabad, commercial cleaning Ahmedabad, janitorial services Ahmedabad, Bodakdev housekeeping, Satellite cleaning services, SG Highway facility services, Thaltej housekeeping, Narol facility management, Vastrapur cleaning, Prahlad Nagar office support';

export const OG_SHARE_IMAGE_WIDTH = 1200;
export const OG_SHARE_IMAGE_HEIGHT = 630;

/** Fallback when a service has no photo — golden wordmark (`KHP_LOGO.svg`), not legacy KFMS circle art. */
export const SERVICE_CARD_FALLBACK_IMAGE = SITE_LOGO_PATH;

/** Map stored/CMS URLs that still point at old KFMS artwork to the current logo. */
export function normalizeLegacyServiceImageUrl(url) {
  if (!url || typeof url !== 'string') return SERVICE_CARD_FALLBACK_IMAGE;
  if (url.includes('KFMS_LOGO')) return SERVICE_CARD_FALLBACK_IMAGE;
  return url;
}
